import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { AvatarCallCenterAgentStatus, AvatarAgentStatus } from '../../common';
export var AgentStatusIndicator = function (props) {
    var size = props.size || 'normal';
    var additionalClassNames = {
        'is-glowing': props.showGlow &&
            props.status !== AvatarCallCenterAgentStatus.OFFLINE &&
            props.status !== AvatarAgentStatus.OFFLINE
    };
    var classNames = namespacedClassnames('status-indicator', additionalClassNames, size, { active: props.active });
    return (React.createElement("span", { className: classNames, "data-status": props.status }));
};
//# sourceMappingURL=status-indicator.js.map